function getClientId() {
    const app_container = new URLSearchParams(window.location.search).get(
        "app_container",
    );
    if (app_container) {
        return `penny${app_container}`;
    }
    const fromSessionStorage = sessionStorage.getItem("account-client-id");
    if (fromSessionStorage) {
        return fromSessionStorage;
    }
    return "account-console";
}

export const clientId = getClientId();